import Snappy from '../libs/snappy/snappy';
import OptaService from '../libs/optaService/optaService';
import EcalService from '../libs/eCalService/eCalService';
import Twitter from '../libs/social/twitter';
import objectFitImages from 'object-fit-images';
import LoadStacklaWidget from '../components/cfa-load-stackla-widget/scripts/load-stackla-widget';


objectFitImages(document.querySelectorAll('img:not(.lazyload)'));

import '../components/resizement/scripts/resize';
import '../.modernizrrc';
import '../styles/main.scss';
import '../styles/eng-ms.scss';

require('./bootstrapComponents');
require('./globalConfigs');
require('./pollyfills');
require('./picturefill');
require('./utilities/hbs-helpers');
require('../libs/validation/serverValidation');
require('../components/lazyimages/scripts/lazyimages');
require('../components/cfa-nav/scripts/cfa-nav');
require('../components/video/scripts/video');
require('../components/responsive-video/scripts/responsive-video');
require('../components/navigation/scripts/navigation');
require('../components/subNavigation/scripts/subNavigation');
require('../components/footer/scripts/footer');
require('../components/modal/scripts/modal');
require('../components/carousel/scripts/carousel');
require('../components/global-heroCarousel/scripts/global-hero-carousel');
require('../components/rowStrip/scripts/rowStrip');
require('../components/rowHeading/scripts/rowHeading');
require('../components/inputField/scripts/inputField');
require('../components/textarea/scripts/textarea');
require('../components/contentPromo/scripts/contentPromo');
require('../components/contentPromoHero/scripts/contentPromoHero');
require('../components/contentPromoVideo/scripts/contentPromoVideo');
require('../components/signpostContentPromo/scripts/signpostContentPromo');
require('../components/signpostContentPromoHero/scripts/signpostContentPromoHero');
require('../components/signpostContentPromoLinkList/scripts/signpostContentPromoLinkList');
require('../components/signpostContentPromoQuote/scripts/signpostContentPromoQuote');
require('../components/tickets/scripts/tickets');
require('../components/findFootball/scripts/findFootball');
require('../components/findCourse/scripts/findCourse');
require('../components/breadcrumbs/scripts/breadcrumbs');
require('../components/poll/scripts/poll');
require('../components/backToTop/scripts/backToTop');
require('../components/latestScoresFixtures/scripts/latestScoresFixtures');
require('../components/liveScores/scripts/liveScores');
require('../components/cookie/scripts/cookie');
require('../components/survey/scripts/survey');
require('../components/faqs/scripts/faqs');
require('../components/contactForm/scripts/contactForm');
require('../components/topbar/scripts/topbar');
require('../components/pageMedia/scripts/pageMedia');
require('../components/gallery/scripts/gallery');
//require('../components/socialShare/scripts/socialShare');
require('../components/relatedContent/scripts/relatedContent');
require('../components/campaign/scripts/campaign');
require('../components/articleTable/scripts/articleTable');
require('../components/quote/scripts/quote');
require('../components/usefulResources/scripts/usefulResources');
require('../components/communityAwards/scripts/nominationForm');
require('../components/filters/scripts/filters');
require('../components/leagueTable/scripts/league-table.js');
require('../components/fixturesAndResults/scripts/fixtures-and-results');

require('../components/countdown/scripts/_countdown');

require('../components/comparisonTool/scripts/comparisonTool');
require('../components/suspensions/scripts/suspensions');

require('../components/cw-footer/scripts/footer');
require('../components/cw-enquiryForm/scripts/enquiryForm');
require('../components/cw-enquiryForm/scripts/hospitalityEnquiryForm.js');
require('../components/cw-newsletterForm/scripts/newsletterForm');
require('../components/video-seats/scripts/video');
require('../components/accordion/scripts/accordion');
require('../components/dropdown/scripts/dropdown');
require('../components/alternate-dropdown/scripts/alternate-dropdown');
require('../components/content-loader/scripts/contentLoader');
require('../components/related-documents/scripts/related-documents');
require('../components/scrollto/scripts/scrollto');
require('../components/media-gallery/scripts/media-gallery');
require('../components/moodboard/scripts/moodboard');
require('../components/tabs/scripts/tabs');
require('../components/disciplinary-search/scripts/disciplinary-search');
require('../components/tracking/scripts/tracking');
require('../components/cfa-search-results/scripts/cfa-search-results');
require('../components/cfa-search-results/scripts/cfa-clear-field');
require('../components/course-table/scripts/cfa-course-table');
require('../components/ws-vfs/scripts/vfs');
require('../components/ws-sofa-to-seat/scripts/sofa-to-seat');
require('../components/ws-meetings-events/scripts/meetings-events');
require('../components/ws-enquiry-form/scripts/enquiry-form');
require('../components/modal-video/scripts/modal-video');
require('../components/esc-redesign/scripts/esc-home');
require('../components/esc-redesign/scripts/esc-list-view-fixture');
require('../components/eng-ms-escMembershipHistory/scripts/esc-membership-history');
require('../components/eng-ms-escprofile/scripts/esc-profile');
require('../components/amgVideo/scripts/amg-video');
require('../components/faNews/scripts/fa-news');
//require('../components/eng-ms-content-tabs/scripts/content-tabs-fa');

//bootroom components
require('../components/mouseover-arrow/scripts/mouseover-arrow');
require('../components/edu-feedback/scripts/edu-feedback');
require('../components/edu-sitenavigation/scripts/edu-sitenavigation');
require('../components/edu-intro-tour/scripts/global-intro-tour');

Snappy.init();
OptaService.init();
EcalService.init();
Twitter.init();

var loadStacklaWidget = new LoadStacklaWidget;
loadStacklaWidget.loadWidget(document, 'stackla-widget-js');

const files = require.context('../assets/svg', true, /^\.\/.*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./scripts/main.js